



















































import Vue from 'vue';
import { Component, Prop, Watch, Model } from 'vue-property-decorator';
import { EnvironmentType, FilePreview, FilePreviewOptions } from '@sgs/file-preview-client-vue';
import { env } from '@/env';
import translationsService from '@/services/translations';
import FilePreviewHocr from './FilePreviewHocr.vue';

@Component({
  name: 'FilePreviewPopupComponent',
  components: {
    FilePreview,
    FilePreviewHocr
  }
})
export default class FilePreviewPopupComponent extends Vue {
  @Model()
  public show!: boolean;
  @Prop()
  public documentId!: string;
  @Prop()
  public fileName!: string;
  @Prop()
  public target!: string;
  @Prop()
  public downloadFileHandler!: (documentId: string, fileName: string, target: string) => any;

  private showDialog = false;
  private showHocrOriginalText = true;
  private showHocrTranslatedText = true;

  private options: FilePreviewOptions = {
    sgsToken: '',
    applicationId: env.applicationId || '',
    environment: (env.environment as EnvironmentType)
  };

  @Watch('showDialog')
  private showDialogEvent(show: any) {
    this.$emit('show', show);
  }

  @Watch('show')
  private async previewFile(show: boolean) {
    if (!show) {
      return;
    }
    try {
      this.$emit('loading', 'Loading document preview, please wait ...');
      if (!this.isHocr) {
        const filePreviewUrlAndToken = await translationsService.getFilePreviewUrlAndToken(
          this.documentId,
          this.target
        );
        this.options.sgsToken = filePreviewUrlAndToken.previewToken;
        const filePreviewComponent = this.$refs.fileViewer as FilePreview;
        await filePreviewComponent.previewFileFromUrl(filePreviewUrlAndToken.previewUrl);
      } else {
        this.showHocrOriginalText = true;
        this.showHocrTranslatedText = true;
        const filePreviewHocrComponent = this.$refs.fileViewerHocr as FilePreviewHocr;
        await filePreviewHocrComponent.previewHocr(this.documentId, this.target);
      }
      this.showDialog = this.show;
    } catch (error) {
      this.onError(error);
    }
  }

  @Watch('showHocrOriginalText')
  private showHocrOriginalTextEvent(show: any) {
    if (!show) {
      this.showHocrTranslatedText = true;
    }
    // eslint-disable-next-line no-undef
    $('.ocr_line>.ocrx_word').toggle(show);
  }

  @Watch('showHocrTranslatedText')
  private showHocrTranslatedTextEvent(show: any) {
    if (!show) {
      this.showHocrOriginalText = true;
    }
    // eslint-disable-next-line no-undef
    $('.translation').toggle(show);
  }

  private onError(error: any) {
    this.$emit('error', 'There was an error previewing this document, please try again', error);
  }

  private onLoaded() {
    this.$emit('loaded');
  }

  get isHocr() {
    return this.fileName.indexOf('.hocr') > -1;
  }
}
